import api from "@/config/axiosConfig";
import { PopularTrip, Trip } from "@/types/trip";
import {
  ConnectionsData,
  ConnectionsResponse,
  UserVisibleTripsResponse,
} from "@/types/social";

class SocialService {
  async shareTrip(
    tripId: string,
    ownerId: string,
    userIds: string[]
  ): Promise<void> {
    const response = await api.social.post(`/trips/${tripId}/share`, {
      recipient_ids: userIds,
    });
    return response.data;
  }

  async createEngagement(
    tripId: string,
    type: "like" | "share",
    metadata?: Record<string, any>
  ): Promise<void> {
    const response = await api.social.post(`/trips/${tripId}/engagement`, {
      type,
      metadata,
    });
    return response.data;
  }

  async getExplorePageTrips(): Promise<{
    success: boolean;
    message: string;
    data: PopularTrip[];
  }> {
    const response = await api.social.get("/explore/trips");
    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.trips.map((trip: any) => ({
        trip_id: trip.trip_id,
        name: trip.trip_name,
        description: trip.trip_description,
        tags: trip.trip_tags,
        images: trip.trip_images,
        locations: trip.trip_locations,
        like_count: trip.like_count,
        share_count: trip.share_count,
        participants: trip.participants,
      })),
    };
  }

  async getUserConnections(userId: string): Promise<ConnectionsResponse> {
    const response = await api.social.get(`/connections/${userId}`);
    return response.data;
  }

  async getUserVisibleTrips(userId: string): Promise<UserVisibleTripsResponse> {
    const response = await api.social.get(`/users/${userId}/trips`);
    return response.data;
  }
}

export const socialService = new SocialService();
export default socialService;
